import { adminApi } from '@redux/api/adminApi';
import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '@typings/rootSlice';

const setDocumentTree = (state, { payload }) => {
    const ns = state.namespace;
    state.tree[ns] = { ...(state.tree[ns] || {}), ...payload };
    state.documentBody = payload[state.name]?.body;
};

const setDocuments = (state, { payload }) => {
    const ns = state.namespace;
    state.tree[ns] = { ...(state.tree[ns] || {}), ...payload };
};

const setDocumentChildren = (state, { payload }) => {
    const ns = state.namespace;
    const children = payload.reduce((acc, child) => ({ ...acc, [child.title_for_url]: child }), {});
    state.tree[ns] = { ...(state.tree[ns] || {}), ...children };
};

const setNamespaces = (state, { payload }) => {
    state.namespaceMap = payload.reduce((acc, ns) => ({ ...acc, [ns.id]: ns.title_for_url }), {});
};

const documentSlice = createSlice({
    name: 'documentSlice',
    initialState,
    reducers: {
        setDocumentName(state, action) {
            state.name = action.payload;
        },
        setNamespace(state, action) {
            state.namespace = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(adminApi.endpoints.getDocumentTree.matchFulfilled, setDocumentTree)
            .addMatcher(adminApi.endpoints.getDocumentChildren.matchFulfilled, setDocumentChildren)
            .addMatcher(adminApi.endpoints.getDocuments.matchFulfilled, setDocuments);
        if (adminApi.endpoints.getNamespaces) {
            builder.addMatcher(adminApi.endpoints.getNamespaces.matchFulfilled, setNamespaces);
        }
    },
});

export const { setDocumentName, setNamespace } = documentSlice.actions;

export default documentSlice.reducer;
